<template>
 <div v-bind:class="{ 'reservation-notes-modal': true, show: show }">
    <div class="reservation-notes-modal-container">
      <div class="reservation-notes-modal-content">
        <div class="notes-modal" v-show="!showComplete && !refundModal.show">
          <div class="title">
            <span v-if="actionData.title">{{ actionData.title }}</span>
            <span v-else>{{ $t('rsvpNotes.title.regular') }}</span>
          </div>

          <i v-show="cancelFeeLoading" class="fa fa-spinner fa-spin fa-fw fa-2x cancel-fee-loader"></i>
          <transition name="fade">
            <div class="cancellation-fee" v-show="!cancelFeeLoading && cancellationFee > 0 && notesAction !== '' && !parseInt(isConvertCredit)">
              <span>
                The customer will have to pay a cancellaton fee of <b>${{ toFixed(cancellationFee) }}</b>.
                Do you want to charge the cancellation fee?
              </span>
              <label>
                <input type="radio" name="cancelFee" value="1" v-model="cancelFee">
                Yes
              </label>
              <label>
                <input type="radio" name="cancelFee" value="0" v-model="cancelFee">
                No
              </label>
            </div>
          </transition>

          <div class="cancellation-fee" v-if="notesData.isLyftService">
            The customer will have to pay a cancellation fee. <br/>
            The final charge is set by Lyft.
          </div>

          <div class="notes-custom-label" v-html="label" v-show="!!label"></div>

          <div v-if="isFullRefund && actionData.amount && parseFloat(actionData.amount) > 0"
            class="full-refund">
            <span v-html="$t('rsvpNotes.payCancellationFee', {amount: '$' + actionData.amount })"></span>
            <label>
              <input type="radio" name="fullRefund" value="0" v-model="fullRefundCharge">
              {{ $t('rsvpNotes.no') }}
            </label>
            <label>
              <input type="radio" name="fullRefund" value="1" v-model="fullRefundCharge">
              {{ $t('rsvpNotes.yes') }}
            </label>
          </div>

          <div v-if="isPartialRefund" class="partial-refund">
            <label>{{ $t('rsvpNotes.refundType') }}:</label>
            <div :class="{'refund-field':true, 'show-input':refundType !== 'full'}">
              <select v-model="refundType" @change="changeRefundType">
                <option value="full" :disabled="refundDisable.full">{{ $t('rsvpNotes.fullRefund') }}</option>
                <option value="partial" :disabled="refundDisable.partial">{{ $t('rsvpNotes.partialRefund') }}</option>
                <option value="credit" :disabled="refundDisable.credit">{{ $t('rsvpNotes.issueCredit') }}</option>
                <option value="charge" :disabled="refundDisable.charge">{{ $t('rsvpNotes.additionalCharge') }}</option>
              </select>
              <div class="refund-input">
                <i class="fas fa-dollar-sign fa-lg "></i>
                <input type="number" step="any" ref="refundInput" v-model="refundAmount" :class="{'has-error':!!refundAmountError}" />
              </div>
              <transition name="slide-down">
                <span class="has-error" v-if="!!refundAmountError">{{ refundAmountError }}</span>
              </transition>
            </div>
          </div>

          <div class="cancel-reason" v-show="notesAction === 'cancel'">
            <label>Passenger Reason for Cancellation:</label>
            <select v-model="cancellation.selectedReason" v-bind:class="{ 'select-error': cancellation.selectError }">
              <option value="-1">Choose one</option>
              <option :value="index" v-for="(value, index) in cancellation.reasons">{{ value }}</option>
            </select>
            <div class="cancel-error" v-show="cancellation.selectError">Please select a reason</div>
            <div v-show="cancellation.selectedReason === 11">
              <textarea v-model="cancellation.customReason" v-bind:class="{ error: cancellation.showError }"></textarea>
              <div v-bind:class="{ 'error-message': true, show: cancellation.showError }">Please provide a reason</div>
            </div>
          </div>

          <div class="cancel-reason cancellation" v-show="notesAction === 'convertCredit'">
            <label>Passenger wants to:</label>
            <div class="optionRefund">
              <label>
              <input type="radio" name="isConvertCredit" value="0" v-model="isConvertCredit">
                Cancel Reservation
              </label>
            </div>
            <div class="reason-select" v-show="!parseInt(isConvertCredit)">
              <label class="reason">Passenger Reason for Cancellation:</label>
              <select v-model="cancellation.selectedReason" v-bind:class="{ 'select-error': cancellation.selectError }">
                <option value="-1">Choose one</option>
                <option :value="index" v-for="(value, index) in cancellation.reasons">{{ value }}</option>
              </select>
            </div>
            <div class="cancel-error" v-show="cancellation.selectError">Please select a reason</div>
            <div class="reason-select" v-show="cancellation.selectedReason === 11 && !parseInt(isConvertCredit)">
              <textarea v-model="cancellation.customReason" v-bind:class="{ error: cancellation.showError }"></textarea>
              <div v-bind:class="{ 'error-message': true, show: cancellation.showError }">Please provide a reason</div>
            </div>
            <div class="optionRefund" v-if="!notesData.isLyftService">
              <label>
              <input type="radio" name="isConvertCredit" value="1" v-model="isConvertCredit">
                Convert to Ride Credits
              </label>
            </div>
          </div>

          <div class="notes">
            <label>{{ $t('rsvpNotes.notes') }}:</label>
            <div ref="noteTextArea" :class="['textarea', {error: noteError}]" @input="populate"></div>
            <div :class="['error-message', {show: noteError}]">{{ $t('rsvpNotes.emptyNotes') }}</div>
            <span>{{ $t('rsvpNotes.charLeft', {value : 500 - notes.length}) }}</span>
          </div>
          <div class="status">
            <label>{{ $t('rsvpNotes.status') }}:</label>
            <select v-model="noteStatus">
              <option value="new">{{ $t('rsvpNotes.new') }}</option>
              <option value="investigation">{{ $t('rsvpNotes.investigation') }}</option>
              <option value="resolved">{{ $t('rsvpNotes.resolved') }}</option>
              <option value="availability" v-if="notesData.isProv">AVAILABILITY</option>
            </select>
          </div>
          <div class="controls row">
            <div class="small-6 columns padding-R">
              <a :class="{'button cta warning block small':true, 'disabled':isSubmitting || cancelFeeLoading}"
                href="javascript:;" @click="close">{{ $t('rsvpNotes.cancel') }}</a>
            </div>
            <div class="small-6 columns padding-L">
              <a v-bind:class="{ 'button cta success block small': true, disabled: isSubmitting || cancelFeeLoading}"
                 href="javascript:;" @click="submit">
                <i v-show="isSubmitting" class="fa fa-spinner fa-spin fa-fw"></i>
                <span v-show="!isSubmitting">{{ $t('rsvpNotes.confirm') }}</span>
              </a>
            </div>
          </div>
        </div>

        <div class="success-modal" v-show="showComplete">
          <i class="fas fa-check-circle fa-fw fa-3x"></i>
          <div class="message">
            Success marked
            <span v-if="isPackage">package</span>
            <span v-else>reservation</span>
            as complete.
          </div>
        </div>

        <div class="refund-fail" v-show="refundModal.show">
          <i class="fas fa-exclamation-triangle fa-5x" v-if="refundModal.status === 'error'"></i>
          <i class="far fa-thumbs-up fa-5x" v-else></i>
          <div class="message">{{ refundModal.message }}</div>
          <a :class="['button cta block small', refundModal.status === 'error' ? 'warning' : 'success']"
            @click="close">{{ $t('rsvpNotes.close') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tribute from 'tributejs'
import moment from 'moment'
import ApiRsvpEdit from '@/modules/api/reservation-details/edit'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'reservation-notes-modal',
  data () {
    return {
      noteError: false,
      isSubmitting: false,
      showComplete: false,
      refundType: 'full',
      refundAmount: '',
      refundAmountError: '',
      fullRefundCharge: '1',
      refundModal: {
        show: false,
        message: '',
        status: ''
      },
      cancelFeeLoading: false,
      cancelFee: true,
      cancellationFee: 0,
      isConvertCredit: '0',
      cancellation: {
        reasons: [
          'I booked this by mistake',
          'I\'m not happy with the price',
          'I\'m not happy with the service',
          'My plans changed',
          'My driver had a bad attitude',
          'Duplicate reservation',
          'My driver was late for the pickup',
          'My driver did not arrive',
          'I took an Uber',
          'I took a Lyft',
          'I took a cab',
          'Other'
        ],
        selectedReason: -1,
        customReason: '',
        showError: false,
        selectError: false,
        tmpGetFeeList: []
      }
    }
  },
  computed: {
    notesData () { return this.$store.state.reservationNotes },
    show () { return this.notesData.show },
    notes () { return this.notesData.notes },
    noteStatus: {
      get () { return this.notesData.noteStatus },
      set (value) { this.$store.commit('reservationNotes/setNoteStatus', value) }
    },
    label () { return this.notesData.label },
    admins () { return this.notesData.admins },
    isPackage () { return this.notesData.isPackage },
    isPartialRefund () { return this.notesData.action === 'partialRefund' },
    isFullRefund () { return this.notesData.action === 'fullRefund' },
    actionData () {
      let aData = this.notesData.actionData
      if (aData.disable && aData.disable.indexOf('full') > -1) { this.refundType = 'charge' }
      return this.notesData.actionData
    },
    refundDisable () {
      if (this.actionData && this.actionData.disable) {
        return {
          full: this.actionData.disable.indexOf('full') > -1,
          partial: this.actionData.disable.indexOf('partial') > -1,
          credit: this.actionData.disable.indexOf('credit') > -1,
          charge: this.actionData.disable.indexOf('charge') > -1
        }
      }

      return {
        full: true,
        partial: true,
        credit: true,
        charge: true
      }
    },
    notesAction () { return this.notesData.action }
  },
  methods: {
    populate () {
      let self = this
      let value = self.$refs.noteTextArea.innerHTML || self.notes
      self.noteError = false
      if (value.length > 500) {
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes
        return
      }
      self.$store.commit('reservationNotes/setNotes', value)
    },
    initTribute () {
      let self = this
      let admins = self.$store.state.reservationNotes.admins
      let tribute = new Tribute({
        values: admins,
        // values: [],
        lookup: 'name',
        fillAttr: 'name',
        selectTemplate: function (item) {
          let result = '<span data-id="' + item.original.id + '" class="mention">@' + item.string + '</span>'
          return result
        }
      })
      tribute.attach(self.$refs.noteTextArea)
      self.$refs.noteTextArea.addEventListener('tribute-replaced', e => {
        self.populate()
      })
    },
    close () {
      if (this.isSubmitting || this.cancelFeeLoading) { return }
      this.showComplete = false
      this.refundType = 'full'
      this.refundAmount = 0
      this.refundAmountError = ''
      this.refundModal.show = false
      this.refundModal.message = ''
      this.isConvertCredit = 0
      this.$store.commit('reservationNotes/hide')
    },
    submit () {
      let self = this
      self.refundAmountError = ''
      if (self.isPartialRefund && self.refundType !== 'full') {
        if (self.refundAmount.trim() === '') {
          self.refundAmountError = self.$t('rsvpNotes.refundAmountEmpty')
          self.$nextTick(() => { self.$refs.refundInput.focus() })
          return
        }
        if (parseFloat(self.refundAmount) <= 0) {
          self.refundAmountError = self.$t('rsvpNotes.lowNumber')
          self.$nextTick(() => { self.$refs.refundInput.focus() })
          return
        }
        // let reg = new RegExp('^\\d+$');
        let reg2 = /^-?\d*\.?\d+$/;
        // if (!reg.test(self.refundAmount)) {
        if (!reg2.test(self.refundAmount)) {
          self.refundAmountError = self.$t('rsvpNotes.notNumber')
          self.$nextTick(() => { self.$refs.refundInput.focus() })
          return
        }
      }

      if (self.notes.length <= 0) {
        self.noteError = true
        return
      }

      self.isSubmitting = true

      let noteStore = self.$store.state.reservationNotes
      if (noteStore.noteId !== null) { // UPDATE note
        self.updateNote()
        return
      }

      if (noteStore.driverId !== null) { // DRIVER note
        self.addDriverNote()
        return
      }

      if (noteStore.action === 'cancel' || noteStore.action === 'convertCredit') {
        self.cancelRsvp()
        // self.checkUpcoming()
        return
      }

      if (noteStore.action === 'editRsvp') {
        self.editRsvp()
        return
      }

      if (self.isPartialRefund || self.isFullRefund) {
        self.refundRsvp()
        return
      }

      self.addRsvpNote()
    },
    updateNote () {
      let self = this
      let noteStore = self.$store.state.reservationNotes
      self.sendToApi('/note/' + noteStore.noteId, null, null, noteStore.noteId)
    },
    addDriverNote () {
      let self = this
      let noteStore = self.$store.state.reservationNotes
      let driverId = noteStore.driverId
      self.sendToApi('/provider/' + driverId + '/notes', null, driverId, null)
    },
    cancelRsvp () {
      let self = this
      let selectedReason = self.cancellation.selectedReason
      let cancelReason = self.cancellation.reasons[self.cancellation.selectedReason]
      let chargeFees = self.cancellationFee > 0 ? self.cancelFee : 0
      if (self.cancellation.selectedReason === 11) {
        cancelReason = self.cancellation.customReason
      }
      if(!parseInt(self.isConvertCredit)) {
        if (selectedReason === -1 || selectedReason === '-1') {
          self.cancellation.selectError = true
          self.isSubmitting = false
          return
        }
      }
      self.cancellation.selectError = false
      if (selectedReason === 11 && cancelReason === '') {
        self.cancellation.showError = true
        self.isSubmitting = false
        return
      }
      self.cancellation.showError = false
      let noteStore = self.$store.state.reservationNotes
      let rsvpId = noteStore.rsvpId

      // if (self.cancellationFee > 0) {
      //   chargeFees = self.cancelFee ? 1 : 0
      // }

      self.$store.commit('cancelUpcoming/setData', {
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus,
        reason: cancelReason,
        refundAsCredits: parseInt(self.isConvertCredit),
        cancelFee: self.cancelFee
      })
      self.$sdk.delete('/admin/rsvp/' + rsvpId, {
        token: self.$store.state.session.sessionToken,
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus,
        chargeFees: chargeFees,
        reason: cancelReason,
        refundAsCredits: parseInt(self.isConvertCredit)
      }, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.isSubmitting = false
          self.close()
          return
        }
        self.checkUpcoming()
        // self.isSubmitting = false
        // self.$store.commit('rsvpDetails/setRsvpAction', {
        //   show: true,
        //   message: self.$t('rsvpDetails.cancelSuccess', {rsvpid: rsvpId})
        // })
        // self.close()
      })
    },
    editRsvp () {
      let self = this
      let noteStore = self.$store.state.reservationNotes
      let rsvpId = noteStore.rsvpId

      noteStore.actionData.notes = noteStore.notes
      noteStore.actionData.noteStatus = noteStore.noteStatus

      let id = noteStore.actionData.rsvpId
      ApiRsvpEdit.updateRsvp(self, noteStore.actionData, function (res) {
        self.isSubmitting = false
        self.close()

        let status = 'success'
        let msg = self.$t('rsvpDetails.edit.updateSuccessMsg', {id: id})
        if (res.error) {
          msg = res.error.message
          if (res.error.code === 'GATE402001') {
            msg = 'Unable to update this reservation. Payment information cannot be processed.'
          }
          status = 'error'
        }
        self.$store.commit('rsvpDetails/setShowUpdateReturn', {
          show: true,
          message: msg,
          status: status
        })
      })
    },
    refundRsvp () {
      let self = this
      let noteStore = self.$store.state.reservationNotes
      let rsvpId = noteStore.rsvpId

      let noteData = {
        token: self.$store.state.session.sessionToken,
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus
      }

      let apiUrl = 'refund'
      if (self.isPartialRefund) {
        if (self.refundType !== 'full') {
          apiUrl = self.refundType
          noteData.amount = self.refundAmount
        } else {
          noteData.chargeFees = false
          noteData.cancel = false
        }
      }
      if (self.isFullRefund) {
        noteData.chargeFees = parseFloat(self.actionData.amount) > 0 && self.fullRefundCharge === '1' ? true : false
        noteData.cancel = self.actionData.status === 'Additional Purchase' ? false : true
      }
      self.$sdk.post('/transaction/' + self.actionData.id + '/' + apiUrl, noteData, r => {
        self.isSubmitting = false

        if (r.error) {
          self.refundModal = {
            show: true,
            message: r.error.message,
            status: 'error'
          }
          return
        }

        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.successMessage(apiUrl)
        })

        self.$store.commit('transactions/setRefreshList', true)

        if (self.refundType === 'credit') {
          self.refundModal = {
            show: true,
            message: self.$t('rsvpNotes.successCredit'),
            status: 'success'
          }
          self.addRsvpNote()
          return
        }
        self.addRsvpNote()
        self.close()
      })
    },
    successMessage (x) {
      let msg = this.$t('rsvpNotes.fullRefund')
      if (x === 'partial') msg = this.$t('rsvpNotes.partialRefund')
      if (x === 'credit') msg = this.$t('rsvpNotes.issueCredit')
      if (x === 'charge') msg = this.$t('rsvpNotes.additionalCharge')
      return `${msg} Success!`
    },
    addRsvpNote () {
      let self = this
      let noteStore = self.$store.state.reservationNotes
      let rsvpId = noteStore.rsvpId
      if (noteStore.forComplete) { // When marking an RSVP/Package as complete...
        let url = '/admin/' + (noteStore.isPackage ? 'package' : 'rsvp') + '/' + rsvpId + '/complete'

        self.showComplete = false
        self.$sdk.post(url, {
          token: self.$store.state.session.sessionToken,
          notes: noteStore.notes,
          noteStatus: noteStore.noteStatus
        }, r => {
          self.isSubmitting = false
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            })
            // TODO process error
            console.log(r)
            return
          }

          self.showComplete = true

          setTimeout(() => {
            if (noteStore.fromRsvpDetails) {
              self.showComplete = false
              location.reload()
            } else {
              self.$store.commit('dispatch/removeRsvpInTable', {
                id: rsvpId,
                isPackage: noteStore.isPackage
              })
              self.$store.commit('dispatch/clearCheckedRsvps')
            }
            self.showComplete = false
            self.close()
          }, 1000)

        })
        return
      }

      // Adding a note to RSVP/Package...
      self.sendToApi('/admin/rsvp/' + rsvpId + '/notes', rsvpId, null, null)
    },
    sendToApi (url, rsvpId, driverId, noteId) {
      let self = this
      let noteStore = self.$store.state.reservationNotes

      self.$sdk.post(url, {
        token: self.$store.state.session.sessionToken,
        message: noteStore.notes,
        status: noteStore.noteStatus,
        actionType: noteStore.actionType,
        actionData: noteStore.actionData
      }, r => {
        self.isSubmitting = false
        if (r.error) {
          // TODO process error
          console.log(r)
          return
        }

        let date = moment.utc(r.created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles')
        let user = self.$store.state.session.user
        if (rsvpId !== null) {
          self.$store.commit('rsvpDetails/addNewNotes', {
            id: r.ID,
            date: date.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)),
            message: r.message,
            status: r.status,
            userId: r.adminID,
            name: user.firstName + ' ' + user.lastName,
            picture: user.photoUrl
          })
        }

        if (driverId !== null) {
          self.$store.commit('provider/addNewNotes', {
            id: r.ID,
            date: date.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)),
            message: r.message,
            status: r.status,
            userId: r.adminID,
            name: user.firstName + ' ' + user.lastName,
            picture: user.photoUrl
          })
        }

        if (noteId !== null) {
          let storeUrl = 'rsvpDetails/updateNote'
          if (r.actionType === 'provider_note') {
            storeUrl = 'provider/updateNote'
          }

          self.$store.commit(storeUrl, {
            id: r.ID,
            message: r.message,
            status: r.status
          })
        }
        self.close()
      })
    },
    changeRefundType () {
      let self = this
      if (self.refundType !== 'full') {
        self.$nextTick(() => { self.$refs.refundInput.focus() })
      }
    },
    toFixed (x) { return parseFloat(x).toFixed(2) },
    checkUpcoming () {
      let self = this
      let rsvp = self.$store.state.rsvpDetails.basicInfo
      let cust = rsvp.customerInfo
      self.$sdk.get('/reservations/' + rsvp.tripInfo.id + '/' + cust.firstName + '/' + cust.lastName + '/upcoming', {}, r => {
        if (r.error) {
          self.isSubmitting = false
          self.$store.commit('rsvpDetails/setRsvpAction', {
            show: true,
            message: self.$t('rsvpDetails.cancelSuccess', {rsvpid: rsvp.tripInfo.id})
          })
          self.close()
          return
        }

        let list = []
        r.list.forEach(rsvp => {
          let pickup = rsvp.pickup.split(',')
          let dropoff = rsvp.dropoff.split(',')
          if (rsvp.dispatchStatus == 'upcoming') {
            list.push({
              id: rsvp.ID,
              pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              pickupDateUnix: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('X'),
              pickup: pickup[0],
              dropoff: dropoff[0]
            })
          }
        })

        if (!list.length) {
          self.isSubmitting = false
          self.close()
          self.$store.commit('rsvpDetails/setRsvpAction', {
            show: true,
            message: self.$t('rsvpDetails.cancelSuccess', {rsvpid: rsvp.tripInfo.id})
          })
          return
        }
        list.sort((a,b) => {
          return a.pickupDateUnix - b.pickupDateUnix
        })
        self.$store.commit('cancelUpcoming/setCancelData', {
          // show: true,
          msg: parseInt(self.isConvertCredit) ? `Reservation ${rsvp.tripInfo.id} was credited successfully.` : 'Successfully cancelled reservation.',
          rsvps: list
        })
        self.tmpGetFeeList = [...list]
        self.getFee(self.tmpGetFeeList[0].id)
      })
    },
    getFee (id) {
      let self = this
      self.$sdk.get(`/admin/rsvp/${id}/fee`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (!r.error) {
          self.$store.commit('cancelUpcoming/updateRsvp', {
            id: id,
            cancellationFee: parseFloat(r.amount)
          })
        }
        self.tmpGetFeeList.shift()
        if (self.tmpGetFeeList.length) self.getFee(self.tmpGetFeeList[0].id)
        else {
          self.isSubmitting = false
          self.close()
          self.$store.commit('cancelUpcoming/setCancelData', {show: true})
        }
      })
    },
  },
  watch: {
    show (value) {
      let self = this
      self.noteError = false
      self.isSubmitting = false
      if (value) {
        self.populate()
        self.$store.commit('reservationNotes/setNotes', self.notes || '')
        self.$store.commit('reservationNotes/setNoteStatus', self.noteStatus || 'new')
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes

        let rsvpNotes = self.$store.state.reservationNotes
        if (rsvpNotes.action === 'cancel' || rsvpNotes.action === 'convertCredit') {
          self.cancelFeeLoading = true
          self.cancelFee = 1
          self.$sdk.get('/admin/rsvp/' + rsvpNotes.rsvpId + '/fee', {
            token: self.$store.state.session.sessionToken
          }, r => {
            self.cancelFeeLoading = false
            if (r.error) { return }
            self.cancellationFee = parseFloat(r.amount)
          })
        }
      } else {
        self.$refs.noteTextArea.innerHTML = ''
        self.$store.commit('reservationNotes/setNotes', '')
        self.$store.commit('reservationNotes/setNoteStatus', 'new')
      }
    },
    admins (value) {
      if (value.length <= 0) {
        return
      }
      let self = this
      self.initTribute()
    }
  },
  mounted () {
    /*
    let self = this
    document.addEventListener('keydown', (e) => {
      if (self.show && !self.isSubmitting && e.keyCode === 27) {
        self.close()
      }
    })
    */
  }
}
</script>

<style lang="scss" scoped>
.reservation-notes-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.reservation-notes-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.reservation-notes-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  max-height: 100vh;
  overflow: auto;
}

.notes-modal{

  & .title{
    color: #fff;
    background-color: #0D79F2;
    padding: 10px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .customer-label{
    padding: 15px 15px 5px;
    font-size: 14px;
    color: #333;
  }

  & label{
    display: block;
    font-weight: 700;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
  }

  & .cancel-reason {
    margin-top: 15px;
  }

  & .notes, & .cancel-reason{
    text-align: left;
    padding: 15px;
    & textarea, & .textarea{
      resize: none;
      display: block;
      outline: 0;
      appearance: none;
      box-sizing: border-box;
      width: 100%;
      border: 1px solid rgba(0,0,0,0.35);
      height: 100px;
      font-size: 14px;
      padding: 10px;
      line-height: inherit;
      border-radius: 3px;
      overflow: auto;
      transition: all 250ms;

      &.error {
        border-color: #F20D0D;
        border-width: 2px;
        background-color: rgba(242,13,13,0.03);
        border-radius: 0;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
    }

    & span {
      display: block;
      text-align: right;
      font-size: 12px;
      margin-top: 2px;
      font-weight: 700;
      color: #777;
    }
  }

  & .status, & .cancel-reason {
    text-align: left;
    padding: 0 15px 15px;

    & select{
      display: block;
      outline: 0;
      box-sizing: border-box;
      border: 1px solid rgba(0,0,0,0.35);
      font-size: 14px;
      padding: 10px;

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;
    }
  }

  & .controls{
    padding: 0 15px 15px;

    & .padding-L { padding-left: 7px; }
    & .padding-R { padding-right: 7px; }
  }

  & .error-message{
    background-color: #F20D0D;
    color: #fff;
    font-size: 12px;
    text-align: center;
    font-weight: 700;
    padding: 0 3px;
    height: 0;
    overflow: hidden;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    transition: all 250ms;

    &.show {
      height: 26px;
      padding: 3px 3px;
    }
  }
}

.success-modal {
  padding: 15px 0;

  & i {
    color: #26D97A;
    margin-bottom: 10px;
  }

  & .message { font-weight: 700; color: #555; }
}

.full-refund{
  padding: 10px 20px;
  font-size: 13px;
  background: #f7eeb2;
  border: 1px solid #d0be42;
  border-radius: 4px;
  margin: 10px 10px 0;
  line-height: 140%;

  span{
    display: block;
  }
  label{
    display: inline-block;
    margin: 10px 20px 0;
    cursor: pointer;

    input{
      margin: 0 3px 0 0;
      width: auto;
      display: inline-block;
      vertical-align: -1px;
    }
  }
}

.cancel-fee-loader{
  color: #5da3f0;
  margin-top: 10px;
}
.cancellation-fee{
  padding: 10px 20px;
  font-size: 12.5px;
  background: #f4c6c6;
  border: 1px solid #e75e5e;
  border-radius: 4px;
  margin: 10px 10px 0;
  line-height: 140%;

  span{ display: block; }
  label{
    display: inline-block;
    margin: 10px 20px 0;
    cursor: pointer;

    input{
      margin: 0 3px 0 0;
      width: auto;
      display: inline-block;
      vertical-align: -1px;
    }
  }
}

.cancellation {
  text-align: left;
  padding: 20px;
  padding-bottom: 5px;
  label {
    display: table-cell;
    &:hover {
      cursor: pointer;
    }
  }
  input {
    width: auto !important;
    display: inline-block;
  }
  .reason-select {
    padding: 0 17px;
  }
  .reason {
    margin-top: 5px;
    display: block;
  }
}

.partial-refund{
  padding: 10px;
  text-align: left;

  label{ line-height: 1; }
}
.refund-field{
  line-height: 1;
  display: flex;
  position: relative;

  select{
    padding: 5px;
    font-size: 15px;
    height: 40px;
    vertical-align: top;
  }
  .refund-input{
    vertical-align: top;
    width: 0;
    opacity: 0;
    position: relative;
    transition: all .3s ease-in;

    i{
      position: absolute;
      z-index: 2;
      top: 50%;
      transform: translateY(-50%);
      left: 5px;
      color: #ccc;
    }
    input{
      margin: 0;
      height: 40px;
      border-color: #999;
      padding-left: 22px;
      position: relative;
      border-radius: 0 3px 3px 0;
      z-index: 1;

      &.has-error{ border-color: #ff6115; }
    }
  }
  span.has-error{
    position: absolute;
    top: 100%;
    right: 0;
    padding: 4px 5px;
    background: #ff6115;
    color: #fff;
    font-size: 13px;
    line-height: 1;
    transform-origin: top center;
  }
  &.show-input{
    select{
      border-right: none;
      border-radius: 3px 0 0 3px;
    }
    .refund-input{
      width: 140px;
      opacity: 1;
    }
  }
}

.refund-fail{
  padding: 20px;

  i {
    margin-bottom: 10px;
    &.fa-exclamation-triangle{ color: #ffc800; }
    &.fa-thumbs-up{ color: #26d97a; }
  }
  .message{
    font-size: 15px;
    margin-bottom: 20px;
  }
}
.cancel-error {
  background-color: red;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  padding: 5px;
}
.select-error {
  border: 2px solid red !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>

<style lang="scss">
.notes-custom-label{
  padding: 15px;
  font-size: 14px;

  .text-left{ text-align:left; }
  .price-difference{
    margin-top: 10px;
    span{
      display: inline-block;
      margin: 0 10px;
      font-weight: 600;

      &.lower{ color: #F20D0D; }
      &.higher{ color: #26D97A; }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .reservation-notes-modal.show {
    .notes-modal {
      height: 100vh;
      overflow: scroll;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/ReservationNotesModal.vue